import ClientNavbar from "../components/ClientNavbar";
import Footer from "../components/Footer";

import "../styles/about.css";

function About() {
  return (
    <>
      <ClientNavbar />

      <div className="about-page">

        <div className="about-hero">

          <h1>About CompExams</h1>

          <p>
            Your trusted platform for accessing
            quality examination papers from
            junior, senior secondary and professional
            institutions.
          </p>

        </div>

        <section className="about-section">

          <div className="about-card">

            <h2>Our Mission</h2>

            <p>
              To make quality examination resources
              accessible to every student, helping
              them prepare effectively and succeed
              academically.
            </p>

          </div>

          <div className="about-card">

            <h2>Our Vision</h2>

            <p>
              To become East Africa's leading online
              examination repository where students
              can confidently prepare for their
              exams.
            </p>

          </div>

          <div className="about-card">

            <h2>Why Choose CompExams?</h2>

            <ul>
              <li>✔ Verified examination papers</li>
              <li>✔ Fast downloads</li>
              <li>✔ Affordable premium content</li>
              <li>✔ Easy search and filtering</li>
              <li>✔ Mobile-friendly platform</li>
            </ul>

          </div>

        </section>

      </div>

      <Footer />
    </>
  );
}

export default About;